import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  FaArrowLeft,
  FaComment,
  FaCalendar,
  FaClock,
  FaUser,
  FaEnvelope,
  FaStar,
  FaBell,
  FaExchangeAlt,
  FaTimes,
  FaMoneyBillWave,
  FaCheck,
} from "react-icons/fa";
import { CiCalendar, CiMail } from "react-icons/ci";
import { FaRegClock } from "react-icons/fa";
import { FiUser } from "react-icons/fi";
import { IoChatbubbleOutline } from "react-icons/io5";
import { MdHistory } from "react-icons/md";
import { GrSecure } from "react-icons/gr";
import { BsCurrencyDollar } from "react-icons/bs";
import ReviewsAndRatings from "./ReviewsAndRatings";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { getCreatorBookings } from "../../redux/actions/mindfulness";
import { Loader } from "./MindfulnessStyles";

const BookingDetailsPage = () => {
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);

  const bookingId = location.state?.bookingId;

  const dispatch = useDispatch();

  const bookingData = useSelector((state) => state?.mindfulness.bookingDetails);
  // const bookingData = testBookingData;

  useEffect(() => {
    const fetchBooking = async () => {
      if (bookingId) {
        await dispatch(getCreatorBookings(bookingId));
        setIsLoading(false);
      }
    };
    fetchBooking();
  }, [bookingId, dispatch]);

  // Format date from ISO string
  const formatDate = (isoString) => {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  // Format time from ISO string
  const formatTime = (isoString) => {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  // Calculate payment details
  const calculatePayment = () => {
    if (!bookingData?.creator_session?.conversation_type_amount) {
      return { sessionFee: 0, platformFee: 0, earnings: 0 };
    }
    const sessionFee = bookingData.creator_session.conversation_type_amount[bookingData.type] || 0;
    const platformFee = Math.round(sessionFee * 0.1); // 10% platform fee
    const earnings = sessionFee - platformFee;
    return { sessionFee, platformFee, earnings };
  };

  const paymentDetails = calculatePayment();

  console.log("Booking id", bookingId);
  console.log("booking data", bookingData);

  if (isLoading || !bookingData) {
    return <Loader />;
  }

  return (
    <Container>
      {/* <Header>
        <BackButton>
          <FaArrowLeft /> Dashboard
        </BackButton>
      </Header> */}

      <MainContent>
        <LeftColumn>
          {/* Session Information */}
          <Card>
            <CardTitle>Session Information</CardTitle>

            <InfoRow>
              <IconWrapper color="#FEF2F2">
                <IoChatbubbleOutline size={24} color="#ED1E24" />
              </IconWrapper>
              <InfoContent>
                <Label>Session Type</Label>
                <Value>{bookingData?.creator_session?.name || "N/A"}</Value>
                <SessionTypeBadge>
                  {bookingData?.type?.charAt(0).toUpperCase() + bookingData?.type?.slice(1) || "N/A"} Session
                </SessionTypeBadge>
              </InfoContent>
            </InfoRow>

            {/* <Divider /> */}

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                alignItems: "center",
                gap: "1rem",
                marginTop: "1rem",
              }}
            >
              <InfoRow>
                <IconWrapper color="#FAF5FF">
                  <CiCalendar size={24} color="#9810FA" />
                </IconWrapper>
                <InfoContent>
                  <Label>Scheduled Date</Label>
                  <Value>{formatDate(bookingData?.start_time)}</Value>
                </InfoContent>
              </InfoRow>

              <InfoRow>
                <IconWrapper color="#FFF7ED">
                  <FaRegClock size={24} color="#F54900" />
                </IconWrapper>
                <InfoContent>
                  <Label>Scheduled Time</Label>
                  <Value>{formatTime(bookingData?.start_time)}</Value>
                </InfoContent>
              </InfoRow>
            </div>
          </Card>

          {/* Student Information */}
          <Card>
            <CardTitle>Student Information</CardTitle>

            <InfoRow>
              <IconWrapper color="#EFF6FF">
                <FiUser size={24} color="#1976d2" />
              </IconWrapper>
              <InfoContent>
                <Label>Student Name</Label>
                <Value>{bookingData?.user?.name || "N/A"}</Value>
                {bookingData?.user?.user_category === "STUDENT" && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <GrSecure color="#e17100ff" />
                    <PrivacyText>
                      {" "}
                      Anonymous profile (privacy protected)
                    </PrivacyText>
                  </div>
                )}
              </InfoContent>
            </InfoRow>

            <InfoRow>
              <IconWrapper color="#F0FDF4">
                <CiMail size={24} color="#4caf50" />
              </IconWrapper>
              <InfoContent>
                <Label>Email Address</Label>
                <Value>Contact via platform</Value>
              </InfoContent>
            </InfoRow>

            <Divider />

            <InfoRow>
              <IconWrapper>
                <MdHistory size={24} color="#6A7282" />
              </IconWrapper>
              <InfoContent>
                <Label>
                  Previous Sessions:{" "}
                  {bookingData?.previous_bookings?.length || 0}
                </Label>
                {bookingData?.previous_bookings && bookingData.previous_bookings.length > 0 ? (
                  <SessionList>
                    {bookingData.previous_bookings.map(
                      (session, index) => (
                        <SessionItem key={index}>
                          <SessionDate>{formatDate(session.start_time)}</SessionDate>
                          <SessionType>{session.type}</SessionType>
                          <SessionRating>{session.rating || "N/A"}</SessionRating>
                        </SessionItem>
                      ),
                    )}
                  </SessionList>
                ) : (
                  <Value>No previous sessions</Value>
                )}
              </InfoContent>
            </InfoRow>
          </Card>

          {/* <ReviewsAndRatings /> */}
        </LeftColumn>

        <RightColumn>
          {/* Actions */}
          <Card>
            <CardTitle>Actions</CardTitle>

            <ActionButton primary onClick={() => console.log("Start Session")}>
              <IoChatbubbleOutline /> Start Session Now
            </ActionButton>

            <ActionButton light onClick={() => console.log("Contact Student")}>
              <CiMail /> Contact Student
            </ActionButton>

            <ActionButton pastel onClick={() => console.log("Send Reminder")}>
              <FaBell /> Send Reminder
            </ActionButton>

            <ActionButton warning onClick={() => console.log("Reschedule")}>
              <FaExchangeAlt /> Reschedule Session
            </ActionButton>

            <ActionButton danger onClick={() => console.log("Cancel Booking")}>
              <FaTimes /> Cancel Booking
            </ActionButton>
          </Card>

          {/* Payment Details */}
          <PaymentCard>
            <CardTitle>
              <IconWrapper color="#fff">
                <BsCurrencyDollar size={22} color="#00A63E" />
              </IconWrapper>
              Payment Details
            </CardTitle>

            <PaymentRow>
              <PaymentLabel>Session Fee</PaymentLabel>
              <PaymentValue>₹{paymentDetails.sessionFee}</PaymentValue>
            </PaymentRow>

            <PaymentRow>
              <PaymentLabel>Platform Fee</PaymentLabel>
              <PaymentValue>₹{paymentDetails.platformFee}</PaymentValue>
            </PaymentRow>

            <PaymentDivider />

            <PaymentRow highlight>
              <PaymentLabel>Your Earnings</PaymentLabel>
              <PaymentValue>₹{paymentDetails.earnings}</PaymentValue>
            </PaymentRow>

            <PaymentStatus>
              {/* <FaCheck /> {bookingData?.transaction ? "Payment Received" : "Payment Pending"} */}
              <FaCheck /> { "Payment Received" }
            </PaymentStatus>
          </PaymentCard>

          {/* Session Tips */}
          <TipsCard>
            <CardTitle>Session Tips</CardTitle>
            <TipsList>
              <TipItem>Review student's previous session notes</TipItem>
              <TipItem>Test your chat connection before starting</TipItem>
              <TipItem>Keep session notes for continuity</TipItem>
              <TipItem>Respect student's anonymity preferences</TipItem>
            </TipsList>
          </TipsCard>
        </RightColumn>
      </MainContent>
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  /* background-color: #f8f9fa; */
  font-weight: 400;
  margin-top: 6.25rem;
  font-family: Montserrat;
`;

const Header = styled.div`
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #dee2e6;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    color: #495057;
  }
`;

const MainContent = styled.div`
  display: flex;
  gap: 20px;
`;

const LeftColumn = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const RightColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Card = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  box-sizing: border-box;
  border: 1.28px solid rgba(229, 231, 235, 1);
  border-radius: 12.78px;
  box-shadow: 0px 1.28px 3.8333334922790527px 0px rgba(0, 0, 0, 0.1),
    0px 1.28px 2.555555582046509px -1.28px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 1);
`;

const PaymentCard = styled(Card)`
  background-color: #f0fdf4;
  border: 1px solid #bbf7d0;
`;

const TipsCard = styled(Card)`
  background-color: #f1f5fe;
  border: 1px solid #bfdbfe;
`;

const CardTitle = styled.p`
  margin-bottom: 15px;
  color: #101828;
  display: flex;
  align-items: center;
  gap: 8px;

  color: rgba(16, 24, 40, 1);

  font-family: Montserrat;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 35.78px;
  letter-spacing: 0px;
  text-align: left;
`;

const InfoRow = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  align-items: flex-start;
`;

const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background-color: ${(prop) => prop.color || "ffebee"};
  color: #ff6b6b;
  margin-bottom: 15px;
`;

const InfoContent = styled.div`
  flex: 1;
`;

const Label = styled.div`
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 5px;
`;

const Value = styled.div`
  font-size: 1.125rem;
  font-weight: 400;
  color: #101828;
`;

const PrivacyText = styled.div`
  font-size: 0.75rem;
  color: #e17100ff;
  margin-top: 3px;
`;

const Divider = styled.div`
  height: 1px;
  background-color: #dee2e6;
  margin: 15px 0;
`;

const SessionTypeBadge = styled.span`
  display: inline-block;
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  margin-top: 5px;
`;

const SessionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
`;

const SessionItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
`;

const SessionDate = styled.span`
  font-size: 13px;
  color: #6c757d;
`;

const SessionType = styled.span`
  font-size: 13px;
  color: #495057;
  background-color: #e9ecef;
  padding: 2px 6px;
  border-radius: 12px;
`;

const SessionRating = styled.span`
  font-size: 13px;
  color: #ffc107;
  font-weight: 500;
`;

const ActionButton = styled.button`
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 10px;
  font-size: 0.875rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 10px;
  transition: all 0.2s ease;

  ${(props) =>
    props.primary &&
    `
    background-color: #dc3545;
    color: white;
    
    &:hover {
      background-color: #c82333;
    }
  `}

  ${(props) =>
    props.light &&
    `
    background-color: #e3f2fd;
    color: #1976d2;
    border: 1px solid #90caf9;
    
    &:hover {
      background-color: #bbdefb;
    }
  `}
  
  ${(props) =>
    props.pastel &&
    `
    background-color: #f3e5f5;
    color: #9c27b0;
    border: 1px solid #ce93d8;
    
    &:hover {
      background-color: #e1bee7;
    }
  `}
  
  ${(props) =>
    props.warning &&
    `
    background-color: #fff3e0;
    color: #ff9800;
    border: 1px solid #ffe0b2;
    
    &:hover {
      background-color: #ffe0b2;
    }
  `}
  
  ${(props) =>
    props.danger &&
    `
    background-color: #ffebee;
    color: #dc3545;
    border: 1px solid #ef9a9a;
    
    &:hover {
      background-color: #ffcdd2;
    }
  `}
`;

const PaymentIcon = styled.div`
  font-size: 16px;
  color: #28a745;
`;

const PaymentRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  ${(props) =>
    props.highlight &&
    `
    font-weight: 600;
    color: #28a745;
  `}
`;

const PaymentLabel = styled.div`
  font-size: 14px;
  color: #495057;
`;

const PaymentValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #101828;
`;

const PaymentDivider = styled.div`
  height: 1px;
  background-color: #d1fae5;
  margin: 8px 0;
`;

const PaymentStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #d1fae5;
  color: #16a34a;
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  margin-top: 10px;
  justify-content: center;
  width: fit-content;
`;

const TipsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const TipItem = styled.li`
  font-size: 14px;
  color: #495057;
  margin-bottom: 8px;
  position: relative;
  padding-left: 20px;

  &:before {
    content: "•";
    position: absolute;
    left: 0;
    color: #6c757d;
  }
`;

export default BookingDetailsPage;

const testBookingData = {
  id: 6,
  user: {
    id: 391,
    experience: [],
    education: [],
    certification: [],
    achievement: [],
    volunteer: [],
    skills: [],
    interests: [],
    social_links: null,
    dept_code: null,
    publications: [
      {
        id: 6,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/391/Publications_images/None-superintelligence-WTwr4L._SL1500_.jpg",
        title: "SUPERINTELLIGENCE: Paths, Dangers, Strategies",
        description:
          "Superintelligence asks the questions: what happens when machines surpass humans in general intelligence? Will artificial agents save or destroy us? Nick Bostrom lays the foundation for understanding the future of humanity and intelligent life.",
        url: "https://www.goodreads.com/en/book/show/20527133",
        publication: "Oxford University Press",
        publication_date: "2014-07-14",
        pub_type: "book",
        profile: 391,
      },
      {
        id: 7,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/391/Publications_images/None-one-ring.jpg",
        title: "The One Ring",
        description:
          "The One Ring was among the most powerful artifacts ever created in Middle-earth.",
        url: "https://lotr.fandom.com/wiki/One_Ring",
        publication: "RING45795",
        publication_date: "2018-02-28",
        pub_type: "patent",
        profile: 391,
      },
      {
        id: 8,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/391/Publications_images/None-blockchain-3019121_1280.png",
        title: "BTC White Paper",
        description:
          "A purely peer-to-peer version of electronic cash would allow online\r\npayments to be sent directly from one party to another without going through a financial institution. Digital signatures provide part of the solution, but the main benefits are lost if a trusted third party is still required to prevent double-spending.",
        url: "https://bitcoin.org/bitcoin.pdf",
        publication: "BTC475214",
        publication_date: "2016-02-20",
        pub_type: "paper",
        profile: 391,
      },
      {
        id: 9,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/391/Publications_images/None-stability.png",
        title: "Stable Diffusion - Generative AI",
        description:
          "Stable Diffusion is a generative artificial intelligence (generative AI) model that produces unique photorealistic images from text and image prompts. It originally launched in 2022. Besides images, you can also use the model to create videos and animations. The model is based on diffusion technology and uses latent space. This significantly reduces processing requirements, and you can run the model on desktops or laptops equipped with GPUs.",
        url: "https://aws.amazon.com/what-is/stable-diffusion/",
        publication: "Stability.AI",
        publication_date: "2022-01-02",
        pub_type: "case_study",
        profile: 391,
      },
    ],
    project: [
      {
        id: 2,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/391/Project_images/None-IBM-Watson.jpg",
        name: "Project Watson v4.01",
        description:
          "IBM Watson is a computer system capable of answering questions posed in natural language. It was developed in IBM's DeepQA project",
        start_date: "2023-07-05",
        end_date: "2023-12-28",
        profile: 391,
      },
      {
        id: 3,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/391/Project_images/None-starlink-logo.jpg",
        name: "Project Starlink v3.0",
        description:
          "Starlink is a satellite internet constellation operated by American aerospace company SpaceX, providing coverage to over 65 countries. It also aims for global mobile phone service after 2023. SpaceX started launching Starlink satellites in 2019.",
        start_date: "2019-03-07",
        end_date: "2023-12-31",
        profile: 391,
      },
    ],
    research: null,
    trainingandconference: [
      {
        id: 8,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/391/TrainingAndConference_images/None-React-Logo-Wallpaper-1920x1080-1365404.jpg",
        title: "React - Workshop",
        organization_name: "Meta",
        issue_date: "2023-08-26",
        credential_url: "https://react.dev/reference/react",
        description:
          "React is the library for web and native user interfaces. Build user interfaces out of individual pieces called components written in JavaScript.",
        profile: 391,
      },
      {
        id: 9,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/391/TrainingAndConference_images/None-Typescript_logo-624x624.png",
        title: "TypeScript - Workshop",
        organization_name: "Microsoft",
        issue_date: "2023-11-15",
        credential_url: "https://www.typescriptlang.org/docs/handbook/intro",
        description:
          "TypeScript is a free and open-source high-level programming language developed by Microsoft that adds static typing with optional type annotations to JavaScript.",
        profile: 391,
      },
    ],
    dept_id: "848bb461-0097-46af-95d5-3de55601fbec",
    is_enterprise_admin: false,
    user_category: "STUDENT",
    open_to_work: {
      id: "4d0e42f7-6c3e-4f58-80c4-281cda4fb259",
      job_title: ["SDE"],
      preferred_work_location: ["REMOTE", "ONSITE"],
      start_availability: ["IMMEDIATELY"],
      employment_types: ["FULLTIME", "PARTTIME"],
      visibility: true,
      profile_id: 391,
    },
    expertise: [],
    specialization: [],
    verified_documents: [],
    professional_memberships: [],
    name: "Katherine Pryde",
    professional_title: "",
    experience_years: 0,
    designation: "",
    location: "",
    organisation: "",
    gender: "",
    views: 0,
    is_creator: false,
    profile_pic:
      "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/391/dpImages/391-1518542436-kitty-pryde-headmistress-all-new-x-men-6.jpg",
    cover_pic: null,
    signature: null,
    bookmarks: "",
    profile_link: "HLo0vulI",
    search_appearance: 0,
    tags: "",
    language_known: "",
    language_code: "",
    about: "Member of the X Task Force",
    address: "",
    state: "",
    state_code: "",
    country: "",
    country_code: "",
    dob: null,
    short_bio: "4",
    trainingAndconference_visibility: true,
    research_visibility: false,
    project_visibility: true,
    publications_visibility: true,
    timestamp: "2023-09-20T08:48:21.605767Z",
    u_timestamp: "2026-02-06T04:54:39.273397Z",
    connections: [389],
  },
  creator_session: {
    id: 17,
    creator_name: "Prof. charles xavier",
    average_rating: null,
    total_bookings: 1,
    SessionRating: [],
    creator: {
      id: 389,
      experience: [
        {
          id: "9bf18cd9-f169-4cf6-94f1-358bf80a7775",
          description: "Genetics Researcher",
          upload_img:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Experience_images/9bf18cd9-f169-4cf6-94f1-358bf80a7775-1670351626_13-kartink.jpg",
          title: "Genetics Researcher",
          start_date: "2001-07-12",
          end_date: "2010-01-05",
          employment_type: "Full time Researcher at Oxford University",
          company: "Oxford University",
          timestamp: "2023-12-07T11:43:47.220000Z",
          u_timestamp: "2023-12-12T17:16:18.746895Z",
          profile_id: 389,
        },
        {
          id: "d248dc04-1b10-4dc0-8d3b-fde57d46ad24",
          description:
            "Served as a tenure professor and researcher at Harvard.",
          upload_img:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Experience_images/d248dc04-1b10-4dc0-8d3b-fde57d46ad24-hardvard-1.jpg",
          title: "Professor of Mutant Biology",
          start_date: "2010-03-03",
          end_date: "2020-03-20",
          employment_type: "Tenure Professor and Researcher",
          company: "Harvard University",
          timestamp: "2023-12-07T11:33:33.887775Z",
          u_timestamp: "2023-12-07T11:33:33.887818Z",
          profile_id: 389,
        },
      ],
      education: [
        {
          id: "071fe808-e63c-4a95-8da4-c6afca73af3b",
          description:
            "Advanced clinical training with focus on evidence-based therapies",
          participations: "",
          upload_img: null,
          school: "Harvard University",
          start_date: "2013-09-01",
          end_date: "2015-06-01",
          field_of_study: "Clinical Psychology",
          degree: "Master of Arts",
          grade: "",
          timestamp: "2026-01-08T11:20:37.744359Z",
          u_timestamp: "2026-01-08T11:20:37.744387Z",
          profile_id: 389,
        },
        {
          id: "32a634ec-aa09-4f9f-9949-12c2864850e8",
          description: "",
          participations: "",
          upload_img:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Education_images/32a634ec-aa09-4f9f-9949-12c2864850e8-1636px-Oxford-Universi.png",
          school: "Oxford",
          start_date: "1965-02-16",
          end_date: "1972-05-09",
          field_of_study: "Genetics",
          degree: "PhD in Genetics",
          grade: "A",
          timestamp: "2023-12-22T05:50:11.629414Z",
          u_timestamp: "2023-12-22T05:50:11.629456Z",
          profile_id: 389,
        },
        {
          id: "39cd4e8b-0236-4d33-8b6a-25c032c7b69d",
          description: "",
          participations: "",
          upload_img: null,
          school: "University of California, Berkeley",
          start_date: "2009-09-01",
          end_date: "2013-06-01",
          field_of_study: "Psychology",
          degree: "Bachelor of Arts",
          grade: "",
          timestamp: "2026-01-08T11:20:09.432744Z",
          u_timestamp: "2026-01-08T11:20:09.432776Z",
          profile_id: 389,
        },
        {
          id: "3ea01071-7d68-4adb-bb1b-b321d64c9810",
          description: "",
          participations: "",
          upload_img: null,
          school: "University of California, Berkeley",
          start_date: "2009-09-01",
          end_date: "2013-06-01",
          field_of_study: "Psychology",
          degree: "Bachelor of Arts",
          grade: "",
          timestamp: "2026-01-08T11:20:37.755114Z",
          u_timestamp: "2026-01-08T11:20:37.755142Z",
          profile_id: 389,
        },
        {
          id: "48754bd1-8197-44b9-bdea-7ea23caf4262",
          description: "",
          participations: "",
          upload_img: null,
          school: "University of California, Berkeley",
          start_date: "2009-09-01",
          end_date: "2013-06-01",
          field_of_study: "Psychology",
          degree: "Bachelor of Arts",
          grade: "",
          timestamp: "2026-01-08T11:21:40.331074Z",
          u_timestamp: "2026-01-08T11:21:40.331110Z",
          profile_id: 389,
        },
        {
          id: "978cee71-c88a-48f1-a5ce-596005e52426",
          description:
            "Advanced clinical training with focus on evidence-based therapies",
          participations: "",
          upload_img: null,
          school: "Harvard University",
          start_date: "2013-09-01",
          end_date: "2015-06-01",
          field_of_study: "Clinical Psychology",
          degree: "Master of Arts",
          grade: "",
          timestamp: "2026-01-08T11:20:09.421596Z",
          u_timestamp: "2026-01-08T11:20:09.421626Z",
          profile_id: 389,
        },
        {
          id: "c266e764-0898-43e4-86ec-b70b0ddddc97",
          description:
            "Advanced clinical training with focus on evidence-based therapies",
          participations: "",
          upload_img: null,
          school: "Harvard University",
          start_date: "2013-09-01",
          end_date: "2015-06-01",
          field_of_study: "Clinical Psychology",
          degree: "Master of Arts",
          grade: "",
          timestamp: "2026-01-08T11:21:40.320763Z",
          u_timestamp: "2026-01-08T11:21:40.320791Z",
          profile_id: 389,
        },
      ],
      certification: [
        {
          id: "4a1c9610-b5b4-4658-8806-308a07159e24",
          description: "State-licensed to practice clinical psychology",
          upload_img: null,
          name: "Licensed Clinical Psychologist",
          issuer: "American Psychological Association",
          issue_date: "2016-07-01",
          expiry_date: "2026-07-01",
          certification_id: "",
          certification_url: "https://www.apa.org",
          timestamp: "2026-01-08T11:21:40.361441Z",
          u_timestamp: "2026-01-08T11:21:40.361472Z",
          profile_id: 389,
        },
        {
          id: "920b27d8-1094-4f31-ac3f-0dfbcf8b099e",
          description: "State-licensed to practice clinical psychology",
          upload_img: null,
          name: "Licensed Clinical Psychologist",
          issuer: "American Psychological Association",
          issue_date: "2016-07-01",
          expiry_date: "2026-07-01",
          certification_id: "",
          certification_url: "https://www.apa.org",
          timestamp: "2026-01-08T11:20:37.822623Z",
          u_timestamp: "2026-01-08T11:20:37.822650Z",
          profile_id: 389,
        },
        {
          id: "aba70f93-b10c-4c33-8ca9-5e4d72c59714",
          description:
            "Cybersecurity analyst responsible for monitoring and protecting networks, devices, people, and data.",
          upload_img:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Certifications_images/aba70f93-b10c-4c33-8ca9-5e4d72c59714-1vnlz431qvB1jspmJ.png",
          name: "Network Security",
          issuer: "CCNA",
          issue_date: "2024-03-26",
          expiry_date: "2024-06-27",
          certification_id: "CCN3434",
          certification_url: "https://grow.google/certificates/cybersecurity/",
          timestamp: "2024-03-26T07:46:05.493509Z",
          u_timestamp: "2024-03-26T07:46:05.493552Z",
          profile_id: 389,
        },
      ],
      achievement: [
        {
          id: "03ebd0bd-7261-4732-9564-c2aaa577dca1",
          description:
            "Recognized for outstanding patient outcomes and community impact",
          upload_img: null,
          name: "Excellence in Mental Health Award",
          issuer: "National Alliance on Mental Illness",
          issue_date: "2023-05-15",
          timestamp: "2026-01-08T11:21:40.372194Z",
          u_timestamp: "2026-01-08T11:21:40.372225Z",
          profile_id: 389,
        },
        {
          id: "2614bff1-32aa-47eb-8e4a-0025f18444de",
          description:
            "Awarded for pro-bono counseling services during pandemic",
          upload_img: null,
          name: "Community Service Award",
          issuer: "Mental Health America",
          issue_date: "2021-11-20",
          timestamp: "2026-01-08T11:21:40.391354Z",
          u_timestamp: "2026-01-08T11:21:40.391411Z",
          profile_id: 389,
        },
        {
          id: "477ca97e-8045-4bcf-83e3-007d50208a09",
          description: "Honored for innovative trauma therapy approaches",
          upload_img: null,
          name: "Therapist of the Year",
          issuer: "California Psychological Association",
          issue_date: "2024-03-10",
          timestamp: "2026-01-08T11:20:37.842523Z",
          u_timestamp: "2026-01-08T11:20:37.842550Z",
          profile_id: 389,
        },
        {
          id: "5acb32f7-89c8-4b36-ab12-b1a3deb65fc6",
          description: "Recognized for research contributions to CBT efficacy",
          upload_img: null,
          name: "Early Career Excellence Award",
          issuer: "American Psychological Association",
          issue_date: "2019-06-05",
          timestamp: "2026-01-08T11:21:40.403172Z",
          u_timestamp: "2026-01-08T11:21:40.403201Z",
          profile_id: 389,
        },
        {
          id: "6ecd1d0c-a795-44da-b3ce-9310582dcfe1",
          description: "Honored for innovative trauma therapy approaches",
          upload_img: null,
          name: "Therapist of the Year",
          issuer: "California Psychological Association",
          issue_date: "2024-03-10",
          timestamp: "2026-01-08T11:21:40.381944Z",
          u_timestamp: "2026-01-08T11:21:40.381973Z",
          profile_id: 389,
        },
        {
          id: "7da6cb33-06fa-40c3-8b4c-50a48ee44732",
          description: "Mutant Biology - Why humans mutate",
          upload_img:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Achievement_images/7da6cb33-06fa-40c3-8b4c-50a48ee44732-exp.png",
          name: "PhD in mutant biology",
          issuer: "Cambridge",
          issue_date: "2015-03-27",
          timestamp: "2023-12-03T13:44:15.535120Z",
          u_timestamp: "2023-12-03T13:44:15.535160Z",
          profile_id: 389,
        },
        {
          id: "864d5139-c47f-48f9-aac2-0e0993fdf093",
          description: "Recognized for research contributions to CBT efficacy",
          upload_img: null,
          name: "Early Career Excellence Award",
          issuer: "American Psychological Association",
          issue_date: "2019-06-05",
          timestamp: "2026-01-08T11:20:37.861724Z",
          u_timestamp: "2026-01-08T11:20:37.861751Z",
          profile_id: 389,
        },
        {
          id: "bea46359-48f6-48b4-9175-0c4fbb138b11",
          description:
            "Recognized for outstanding patient outcomes and community impact",
          upload_img: null,
          name: "Excellence in Mental Health Award",
          issuer: "National Alliance on Mental Illness",
          issue_date: "2023-05-15",
          timestamp: "2026-01-08T11:20:37.832276Z",
          u_timestamp: "2026-01-08T11:20:37.832304Z",
          profile_id: 389,
        },
        {
          id: "c2a3b71c-7d4a-4eca-927d-0eb4505eb11b",
          description:
            "Awarded for pro-bono counseling services during pandemic",
          upload_img: null,
          name: "Community Service Award",
          issuer: "Mental Health America",
          issue_date: "2021-11-20",
          timestamp: "2026-01-08T11:20:37.852149Z",
          u_timestamp: "2026-01-08T11:20:37.852259Z",
          profile_id: 389,
        },
      ],
      volunteer: [
        {
          id: "96afba64-dcc0-4d32-ab61-28263ac7f279",
          description:
            "Working with Amnesty International as a volunteer is a deeply rewarding and eye-opening experience. Over time, you become immersed in the global fight for human rights, gaining firsthand insight into pressing social justice issues. The work often involves researching human rights violations, engaging with diverse communities, and collaborating with passionate activists from around the world.",
          role: "Chief Psychoanalyst",
          cause: "Mental Well being",
          upload_img:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/VolunteerExperience_images/96afba64-dcc0-4d32-ab61-28263ac7f279-exp.png",
          organisation: "Amnesty International",
          start_date: "2024-01-08",
          end_date: "2025-03-05",
          timestamp: "2025-07-05T14:52:59.987754Z",
          u_timestamp: "2025-07-05T14:52:59.987815Z",
          profile_id: 389,
        },
      ],
      skills: [
        {
          id: "24b16284-f212-4cc5-b893-a00ef47c03cd",
          upload_img:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/Skills_images/24b16284-f212-4cc5-b893-a00ef47c03cd-GitVersion.png",
          title: "Git/Version Control",
          description: "Git/Version Control",
          status: true,
          timestamp: "2022-02-19T08:34:47.910427Z",
          u_timestamp: "2022-02-19T08:36:06.351571Z",
        },
        {
          id: "2f97c23b-cd03-41ce-966f-516418f56965",
          upload_img:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/Skills_images/2f97c23b-cd03-41ce-966f-516418f56965-javascript.png",
          title: "Javascript",
          description: "Javascript",
          status: true,
          timestamp: "2022-02-19T08:33:49.379566Z",
          u_timestamp: "2022-02-19T08:33:49.379606Z",
        },
      ],
      interests: [
        {
          id: "9520dff6-3964-4cd2-8350-d2ac19fa5b32",
          title: "Reading",
          description: "",
          upload_img:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/Interest_images/9520dff6-3964-4cd2-8350-d2ac19fa5b32-Reading.jpg",
          status: true,
          timestamp: "2022-02-19T08:59:28.307015Z",
          u_timestamp: "2022-02-19T08:59:28.307057Z",
        },
      ],
      social_links: null,
      dept_code: null,
      publications: [
        {
          id: 1,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Publications_images/1-fire-and-blood.jpg",
          title: "House of the Dragon v2",
          description: "Fire & Blood - Stone",
          url: "https://www.westeros.org/",
          publication: "Bantam Press",
          publication_date: "2023-11-08",
          pub_type: "book",
          profile: 389,
        },
        {
          id: 2,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Publications_images/None-1670351626_13-kartinkin-net-p-kartinki-momento-more.jpg",
          title: "LOTR v1",
          description: "Lord of the Rings",
          url: "https://gitlab.com",
          publication: "Bantem",
          publication_date: "0203-01-06",
          pub_type: "book",
          profile: 389,
        },
        {
          id: 3,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Publications_images/None-jnixqvnrzn791.png",
          title: "Witch Hat",
          description:
            "A witch hat is a style of hat worn by witches in popular culture depictions, characterized by a conical crown and a wide brim.",
          url: "https://github.com",
          publication: "WITCH485848",
          publication_date: "2023-02-12",
          pub_type: "patent",
          profile: 389,
        },
        {
          id: 4,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Publications_images/None-61TuTkJmjBL._AC_UF10001000_QL80_.jpg",
          title: "Philosophy of Memento Mori",
          description:
            "Memento mori, in art and spirituality, a symbolic trope or meditative practice that serves as a reminder of mortality and the transitory nature of earthly pleasures. Memento mori is a Latin phrase meaning “remember you must die.” The notion of “remembering death” appears throughout European history, and other cultures have traditions that approach the same concept in unique ways.",
          url: "https://www.britannica.com/topic/memento-mori",
          publication: "MEMO478597",
          publication_date: "2014-11-10",
          pub_type: "paper",
          profile: 389,
        },
        {
          id: 5,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Publications_images/None-Bell-Curve.jpeg",
          title: "Dunning-Kruger Effect",
          description:
            "The Dunning-Kruger effect occurs when a person’s lack of knowledge and skill in a certain area causes them to overestimate their own competence. By contrast, this effect also drives those who excel in a given area to think the task is simple for everyone, leading them to underestimate their abilities.",
          url: "https://thedecisionlab.com/biases/dunning-kruger-effect",
          publication: "Decision Lab Inc.",
          publication_date: "2020-08-07",
          pub_type: "case_study",
          profile: 389,
        },
      ],
      project: [
        {
          id: 1,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Project_images/None-IBM-Watson.jpg",
          name: "Project Watson",
          description:
            "Watson is a computer system capable of answering questions posed in natural language developed by IBM.",
          start_date: "2021-01-05",
          end_date: "2023-12-10",
          profile: 389,
        },
      ],
      research: [
        {
          id: 1,
          research_type: "industry",
          ongoing: true,
          title: "AGI: Artificial General Intelligence",
          industry_name: "IBM Inc.",
          issue_date: "2020-08-07",
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Research_images/None-GBHajSGbgAEULbA.jpeg",
          url: "https://www.ibm.com/topics/strong-ai",
          description:
            "Artificial general intelligence (AGI) or general AI, is a theoretical form of AI used to describe a certain mindset of AI development. If researchers are able to develop Strong AI, the machine would require an intelligence equal to humans; it would have a self-aware consciousness that has the ability to solve problems, learn, and plan for the future.",
          profile: 389,
        },
        {
          id: 2,
          research_type: "other",
          ongoing: false,
          title: "Hyperledger Fabric",
          industry_name: "IBM",
          issue_date: "2015-06-09",
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Research_images/None-hyper.jpeg",
          url: "https://www.ibm.com/topics/hyperledger",
          description:
            "Hyperledger Fabric, an open source project from the Linux Foundation, is the modular blockchain framework and de facto standard for enterprise blockchain platforms.",
          profile: 389,
        },
        {
          id: 3,
          research_type: "industry",
          ongoing: true,
          title: "AGI: Artificial General Intelligence",
          industry_name: "IBM Inc.",
          issue_date: "2020-08-07",
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Research_images/3-GPT-4.jpg",
          url: "https://www.ibm.com/topics/strong-ai",
          description:
            "Artificial general intelligence (AGI) or general AI, is a theoretical form of AI used to describe a certain mindset of AI development. If researchers are able to develop Strong AI, the machine would require an intelligence equal to humans; it would have a self-aware consciousness that has the ability to solve problems, learn, and plan for the future.",
          profile: 389,
        },
      ],
      trainingandconference: [
        {
          id: 1,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/None-IBM-Watson.jpg",
          title: "Training - Generative  AI",
          organization_name: "IBM Inc.",
          issue_date: "2023-09-30",
          credential_url: "https://research.ibm.com/blog/what-is-generative-A",
          description:
            "Generative AI refers to deep-learning models that can generate high-quality text, images, and other content based on the data they were trained on.",
          profile: 389,
        },
        {
          id: 2,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/None-react-workshop-2.png",
          title: "React Workshop 2.0",
          organization_name: "Meta Inc.",
          issue_date: "2023-06-10",
          credential_url: null,
          description:
            "React is a free and open-source front-end JavaScript library for building user interfaces based on components. It is maintained by Meta and a community of individual developers and companies. React can be used to develop single-page, mobile, or server-rendered applications with frameworks like Next.js",
          profile: 389,
        },
        {
          id: 3,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/None-node-logo_bc9pmTiyKR0WNPka2w3e0Q.png",
          title: "Node.JS Workshop",
          organization_name: "OpenJS Foundation",
          issue_date: "2022-06-10",
          credential_url: "https://www.netguru.com/glossary/node-js",
          description:
            "Node.js is an open source, cross-platform runtime environment and library that is used for running web applications outside the client’s browser.",
          profile: 389,
        },
        {
          id: 4,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/None-GBHajSGbgAEULbA.jpeg",
          title: "AGI: Artificial general intelligence",
          organization_name: null,
          issue_date: "2020-03-05",
          credential_url: null,
          description:
            "Artificial General Intelligence (AGI) or general AI, is a theoretical form of AI used to describe a certain mindset of AI development. If researchers are able to develop Strong AI, the machine would require an intelligence equal to humans; it would have a self-aware consciousness that has the ability to solve problems, learn, and plan for the future.",
          profile: 389,
        },
        {
          id: 5,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/5-black-flowers-1330260.png",
          title: "Python Workshop",
          organization_name: "Python Software Foundation",
          issue_date: "2022-02-11",
          credential_url: "https://docs.python.org/3/",
          description:
            "Python is an interpreted, object-oriented, high-level programming language with dynamic semantics developed by Guido van Rossum.",
          profile: 389,
        },
        {
          id: 6,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/None-RedHat_Logo_Whitebg1200x1200.jpg",
          title: "Red Hat Enterprise Linux",
          organization_name: "Red Hat Inc.",
          issue_date: "2021-09-26",
          credential_url: "https://www.redhat.com/en/topics/linux",
          description:
            "Red Hat Enterprise Linux is a distribution of the Linux operating system. The Red Hat organization develops it for the business or the enterprise market. It is also commonly abbreviated as RHEL.",
          profile: 389,
        },
        {
          id: 7,
          image:
            "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/None-GBHajSGbgAEULbA.jpeg",
          title: "Django",
          organization_name: "IBM",
          issue_date: "2023-12-22",
          credential_url: "https://gitlab.com",
          description: "Something",
          profile: 389,
        },
      ],
      dept_id: "848bb461-0097-46af-95d5-3de55601fbec",
      is_enterprise_admin: false,
      user_category: "TEACHER",
      open_to_work: {
        id: "dcea3e7b-4790-4bf1-b323-1fc895cdbcbb",
        job_title: ["Researcher"],
        preferred_work_location: ["ONSITE"],
        start_availability: ["IMMEDIATELY"],
        employment_types: ["FULLTIME"],
        visibility: true,
        profile_id: 389,
      },
      expertise: [
        {
          id: 1,
          name: "Anxiety & Depression Treatment",
          timestamp: "2026-01-08T11:20:09.442922Z",
          u_timestamp: "2026-01-08T11:20:09.442959Z",
          profile: 389,
        },
        {
          id: 2,
          name: "Anxiety & Depression Treatment",
          timestamp: "2026-01-08T11:20:37.764482Z",
          u_timestamp: "2026-01-08T11:20:37.764518Z",
          profile: 389,
        },
        {
          id: 3,
          name: "Trauma Recovery",
          timestamp: "2026-01-08T11:20:37.774755Z",
          u_timestamp: "2026-01-08T11:20:37.774790Z",
          profile: 389,
        },
        {
          id: 4,
          name: "Anxiety & Depression Treatment",
          timestamp: "2026-01-08T11:21:40.340839Z",
          u_timestamp: "2026-01-08T11:21:40.340876Z",
          profile: 389,
        },
        {
          id: 5,
          name: "Trauma Recovery",
          timestamp: "2026-01-08T11:21:40.350806Z",
          u_timestamp: "2026-01-08T11:21:40.350844Z",
          profile: 389,
        },
      ],
      specialization: [
        {
          id: 1,
          name: "Cognitive Behavioral Therapy",
          timestamp: "2026-01-08T11:19:09.712561Z",
          u_timestamp: "2026-01-08T11:19:09.712599Z",
          profile: 389,
        },
        {
          id: 2,
          name: "Couples Counseling",
          timestamp: "2026-01-08T11:19:09.722089Z",
          u_timestamp: "2026-01-08T11:19:09.722126Z",
          profile: 389,
        },
        {
          id: 3,
          name: "Cognitive Behavioral Therapy",
          timestamp: "2026-01-08T11:21:40.299083Z",
          u_timestamp: "2026-01-08T11:21:40.299122Z",
          profile: 389,
        },
        {
          id: 4,
          name: "Couples Counseling",
          timestamp: "2026-01-08T11:21:40.310748Z",
          u_timestamp: "2026-01-08T11:21:40.310786Z",
          profile: 389,
        },
      ],
      verified_documents: [],
      professional_memberships: [
        {
          id: "8507dcf4-c470-4faf-b247-f9f48986f172",
          organisation: "American Psychological Association",
          description: "Active member of Division 12 (Clinical Psychology)",
          start_date: "2016-01-01",
          end_date: "2026-01-01",
          role: "Clinical Psychologist Member",
          timestamp: "2026-01-08T11:20:37.872483Z",
          u_timestamp: "2026-01-08T11:20:37.872512Z",
          profile_id: 389,
        },
        {
          id: "9eeab2f0-ed08-4870-99e4-1046771a694b",
          organisation: "American Psychological Association",
          description: "Active member of Division 12 (Clinical Psychology)",
          start_date: "2016-01-01",
          end_date: "2026-01-01",
          role: "Clinical Psychologist Member",
          timestamp: "2026-01-08T11:21:40.412907Z",
          u_timestamp: "2026-01-08T11:21:40.412937Z",
          profile_id: 389,
        },
      ],
      name: "Prof. charles xavier",
      professional_title: "",
      experience_years: 8,
      designation: "Founder of Xavier's School for Gifted Youngsters",
      location: "NYC",
      organisation: "",
      gender: "",
      views: 0,
      is_creator: true,
      profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      cover_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/coverImages/389-x-2.png",
      signature:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Profile_images/389-signature.png",
      bookmarks: "",
      profile_link: "uLuMmmKY",
      search_appearance: 0,
      tags: "CBT, Mindfulness, Trauma Therapy",
      language_known: "English, Hindi",
      language_code: "en, hi, it",
      about:
        "Compassionate licensed therapist with 8 years of experience helping individuals and couples navigate emotional challenges and build resilience",
      address: "New York",
      state: "",
      state_code: "",
      country: "undefined",
      country_code: "undefined",
      dob: "1975-03-06",
      short_bio: "1",
      trainingAndconference_visibility: true,
      research_visibility: true,
      project_visibility: true,
      publications_visibility: true,
      timestamp: "2023-09-20T08:19:16.646476Z",
      u_timestamp: "2026-02-06T04:55:07.313721Z",
      connections: [391, 392, 399, 410],
    },
    name: "Therapy 101",
    category: "Meditaiton",
    duration: 60,
    description: "",
    conversation_type_amount: {
      call: 700,
    },
    objective: "",
    setting_config: {
      level: "Beginner",
      language: "English",
    },
    is_live: true,
    max_booking_per_day: 15,
    attachments: null,
    is_active: true,
    timestamp: "2026-02-05T11:49:42.477091Z",
    utimestamp: "2026-02-05T11:49:42.477124Z",
  },
  previous_bookings: [],
  type: "call",
  start_time: "2026-02-10T10:00:00Z",
  duration: 60,
  end_time: "2026-02-10T11:00:00Z",
  status: "pending",
  notes: "",
  transaction: null,
  is_active: true,
  timestamp: "2026-02-05T14:11:07.454568Z",
  utimestamp: "2026-02-05T14:11:07.454582Z",
};
